import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MultiSelectModule } from "primeng/multiselect";
import { ErrormessageModule } from '../validation/errormessage/errormessage.module';

import { PCPPurchaseOrderStatusMultiSelectComponent } from "./pcp-purchaseorderstatus-multiselect.component";

@NgModule({
    imports: [
        CommonModule,
        ErrormessageModule,
        FormsModule,
        MultiSelectModule,
        PCPPurchaseOrderStatusMultiSelectComponent
    ],
    exports: [PCPPurchaseOrderStatusMultiSelectComponent]
})
export class PCPPurchaseOrderStatusMultiSelectModule { }
